import { render, staticRenderFns } from "./WorkflowConfig.vue?vue&type=template&id=e278e170&scoped=true&"
import script from "./WorkflowConfig.vue?vue&type=script&lang=js&"
export * from "./WorkflowConfig.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowConfig.vue?vue&type=style&index=0&id=e278e170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e278e170",
  null
  
)

export default component.exports